import { SortItem } from '../ss-api/responses/member.dashboard.license.response';

export enum LogTypes {
    // member
    EditMember = 0,

    // license
    EditLicense = 50,

    // invoice
    Invoice = 2
}

export class MemberLogItem {
    ID: number;
    LogType: LogTypes;
    Subject: string;
    Description: string;
    DateTimeCreated: Date;
    Admin_ID: number;
    FullName: string;
    Member_ID: number;
    License_ID: number;
    LicenseKey: string;
    HasNotes: boolean;

    public static FixDate(item: MemberLogItem) {
        item.DateTimeCreated = new Date(item.DateTimeCreated);
    }
}

export class MemberLogItemArray extends Array<MemberLogItem>  {
    public LastSort = new SortItem;

    constructor(...items: MemberLogItem[]) {
        super(...items);
        Object.setPrototypeOf(this, MemberLogItemArray.prototype);
    }


    public static FixDates(items: MemberLogItemArray) {
        items.forEach(x => MemberLogItem.FixDate(x));
    }

    public static SortByDate( sortThis: MemberLogItemArray ): MemberLogItemArray {
        sortThis.sort((a, b) => {
            if (a.ID < b.ID ) return 1;
            else if (a.ID > b.ID) return -1;
            else return 0;
        });

        return sortThis;
    }

}
